// extracted by mini-css-extract-plugin
module.exports = {"b1nl46oh":"b1nl46oh"};